<template>

  <v-container fluid class="pa-0" >
    <CustomerDetailHeader :customer="customer" >
      <v-row no-gutters v-masonry id="printTarget" >

        <v-col cols="12" sm="6" lg="4" class="pa-1">
          <Basics :customer="customer" :firstVisit="firstVisit" :images="images" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showDemographics">
          <Demographics :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="partnerCode==='eco_bw'">
          <CaNonCa :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1">
<!--          <HrActions :customer="customer" v-if="this.partnerCode==='hr_co'" />-->
          <NileUg :customer="customer" v-if="this.partnerCode==='nile_ug'" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showInputOrders">
          <InputOrders :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1"  v-if="showCropDeliveries">
          <Deliveries :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showFarmerBasics">
          <FarmerBasics :customer="customer" :firstVisit="firstVisit" :cultivationContractAssessment="cultivationContractAssessment" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="show('fields')">
          <Fields :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showCashReceipts">
          <Receipts :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showPurchases">
          <Purchases :customer="customer" />
        </v-col>

<!--        <v-col cols="12" sm="3" lg="1" class="pa-1" v-if="profileImage">-->
<!--          <v-card>-->
<!--            <SingleImage :image="profileImage" />-->
<!--          </v-card>-->
<!--        </v-col>-->

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showLocation">
          <Location v-if="this.partnerCode !='eco_bw'" :customer="customer" />
        </v-col>


        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="locations.length>0">
          <Map :locations="locations" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="(coords || []).length>0">
          <MapPolygons :coords="coords" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="false">
          <FarmerActions :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="(customer.appointments || []).length>0">
          <Appointments :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="showAssessments">
          <Assessments :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="show('delete_customer')">
          <Delete :customer="customer" />
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="partnerCode==='eco_bw'">
          <v-card>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Previous Assessments
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Assessment</th>
                          <th class="text-left">Season</th>
                          <th class="text-left">Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="assessment in previousFieldSurveyAssessments" :key="assessment.uuid">
                          <td class="text-left">{{ getAssessmentName(assessment.assessmentType) }}</td>
                          <td class="text-left">{{ seasonFromDate(new Date(assessment.created_at)) }}</td>
                          <td class="text-left">{{ formatAssessmentDate(assessment.created_at) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="partnerCode==='uzima_ug'">
          <UzimaUgDetail :customer="customer" />
        </v-col>


        <v-col cols="12" sm="6" lg="4" class="pa-1" v-if="partnerCode==='eco_bw'">
          <template v-for="season in seasons">
            <SeasonAssessment
                :year="season"
                :customer="customer"
            />
          </template>
        </v-col>

        <v-col
            cols="12" sm="6" lg="4" class="pa-1"
            v-if="(partnerCode==='eco_bw' && (coords || []).length>0)">
          <CorridorAwarenessLocations
              :coords="coords"
          />
        </v-col>
      </v-row>
    </CustomerDetailHeader>
  </v-container>
</template>


<script>
  import displaySwitches from '@/mixins/displaySwitches';
  import PageHeader from "@/components/PageHeader";
  import Map from '@/components/Map';
  import MapPolygons from '@/components/MapPolygons';
  import Basics from '@/views/customers/components/Basics';
  import Appointments from '@/views/customers/components/Appointments';
  import Fields from '@/views/customers/components/Fields';
  import CaNonCa from '@/views/customers/partners/eco_bw/CaNonCa.vue';
  import InputOrders from '@/views/customers/components/InputOrders';
  import Receipts from '@/views/customers/components/Receipts';
  import Purchases from '@/views/customers/components/Purchases';
  import Deliveries from '@/views/customers/components/Deliveries';
  import Images from '@/components/Images';
  import SingleImage from '@/components/SingleImage';
  import CustomerDetailHeader from '@/views/customers/components/CustomerDetailHeader'
  import FarmerActions from '@/views/customers/components/FarmerActions';
  import FarmerBasics from '@/views/farmers/components/Basics';
  import Demographics from '@/views/customers/components/Demographics';
  import Location from '@/views/customers/components/Location';
  import Assessments from '@/views/customers/components/Assessments';
  import Delete from '@/views/customers/components/Delete';
  import UzimaUgDetail from '@/views/customers/partners/uzima_ug/Detail';
  import HrActions from '@/views/customers/partners/hr_co/HrActions';
  import NileUg from '@/views/customers/partners/nile_ug/NileUg';
  import partnerCodeEnums from "@/mixins/partnerCodeEnums";
  import {assessmentNameEnum} from "@/views/partners/hr_co/constant";
  import Row from "@/components/Row";
  import SeasonAssessment from "@/views/customers/partners/eco_bw/SeasonAssessment";
  import CorridorAwarenessLocations
    from "@/views/customers/components/CorridorAwarenessLocations/CorridorAwarenessLocations.vue";
  import { seasonFromDate } from "@/views/partners/eco_bw/utils";

  export default {

    components: { Map, MapPolygons, Basics, Appointments, Fields, InputOrders, CaNonCa,
      Receipts, Purchases, Deliveries, Images, SingleImage, CustomerDetailHeader, FarmerActions, FarmerBasics,
      Demographics, Location, Assessments, Delete, UzimaUgDetail, HrActions, NileUg,
      Row,
      CorridorAwarenessLocations,
      PageHeader,
      SeasonAssessment
    },

    props: ['customer'],

    computed: {
      partnerCode() { return this.$store.getters.settings.partnerCode },
      images() {
        const storeImages = this.$store.getters.images.filter( e => ( e.type_id===this.customer.uuid ) && (e.type==='customer' || e.type==='demographic') );
        const demographicImageUrls = this.customer.demographic?.imageUrls || [];
        const demographicIdScans = this.customer.demographic?.idScanUrls || [];
        const customerImageUrls = this.customer.imageUrls || [];
        
        const backendUrls = [...demographicImageUrls, ...demographicIdScans, ...customerImageUrls];
        
        if (backendUrls.length > 0) {
          return backendUrls;
        }
        
        return storeImages;
      },
      locations() {
        return (this.customer.demographic ? Object.values(this.customer.demographic.keyLocations || {}) : []).filter( e => e && e.latitude );
      },
      profileImage() {
        let image = undefined;
        // these probably are more recent than anything already uploaded
        let images = this.$store.getters.images.filter( e => ( e.type_id===this.customer.uuid ) && (e.type==='customer') );
        if (images.length>0) { image = images[images.length - 1]; }
        if ( (image==null) && this.customer.imageUrls && (this.customer.imageUrls.length>0) ) {
          image = this.customer.imageUrls[this.customer.imageUrls.length - 1];
        }
        return image;
      },
      coords() {
        return (this.customer.fields || []).map(this.fieldCoords).filter(e => e.coordinates);
      },
      showAssessments() {
        // todo add condition for right partner that needs assessments
        return ((this.customer.assessments || []).length>0 && [this.partnerCodes.hr_co,  this.partnerCodes.eco_bw].includes(this.partnerCode));
      },
      showCropDeliveries() {
        let s = this.show('crop_deliveries');
        if (s && this.partnerCode=='eco_bw') { s = false}
        return s;
      },
      showDemographics() {
        let s = this.show('demographics');
        if (this.partnerCode=='eco_bw') { s = true}
        return s;
      },
      showCashReceipts() {
        let s = this.show('cash_receipts');
        if (s && this.partnerCode=='eco_bw') { s = false}
        return s;
      },
      showFarmerBasics() {
        let s = this.show('agriculture');
        if (s && this.partnerCode=='eco_bw') { s = false}
        return s;
      },
      showLocation() {
        let s = this.show('location_detail');
        return s;
      },
      showInputOrders() {
        let s = this.show('input_orders');
        if (s && (this.partnerCode==='uzima_ug')) {
          let fieldAgentId = this.$store.getters.settings.fieldAgentId;
          s = (fieldAgentId===3029196 || fieldAgentId===3029197 || fieldAgentId===3021053|| fieldAgentId===3006715);
        }
        if (this.partnerCode=='eco_bw') { s = false}
        return s;
      },
      showPurchases() {
        let s = this.show('input_purchases');
        if (s && this.partnerCode=='eco_bw') { s = false}
        // if (s && this.partnerCode==='nile_ug') {
        //   const agentId = this.$store.getters.settings.fieldAgentId;
        //   s = ( agentId===34220 || agentId===3018002 || agentId===3018600 || agentId===3018005 || agentId===3018006 );
        // }
        return s;
      },
      customerAssessments() {
        return this.$store.getters.customerAssessments(this.customer.uuid)
      },
      firstVisit() {
        return this.customerAssessments.find(assessment =>
            assessment.assessmentName === assessmentNameEnum.primeraVisita &&
            assessment.customerUuid === this.customer.uuid
        )
      },
      cultivationContractAssessment() {
        return this.$store.getters.assessments.find(assessment =>
            assessment.assessmentName === assessmentNameEnum.cultivationContract &&
            assessment.customerUuid === this.customer.uuid
        )
      },
      corridorAwarenessAssessment() {
        return this.customer ? this.$store.getters.customerAssessment(this.customer.uuid, 'CorridorAwarenessAssessment') : null;
      },
      seasons() {
        let years = new Set();
        years.add(seasonFromDate(new Date()))
        this.customerAssessments.forEach(a => {
          years.add(seasonFromDate(new Date(a.created_at)))
        })
        return years
      },
      previousFieldSurveyAssessments() {
        return this.customer ? this.customerAssessments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) : [];
      }
    },
    methods: {
      seasonFromDate,
      getAssessmentName(assessmentType) {
        const names = {
          'FieldSurvey': 'Field Survey Assessment',
          'CorridorAwarenessAssessment': 'Corridor Awareness Assessment',
          'PortionSurvey': 'Portion Survey Assessment'
        };
        return names[assessmentType] || assessmentType;
      },
      formatAssessmentDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      fieldCoords(field) {
        return {
          partnerIdentifier: this.customer.partnerIdentifier,
          fieldId: field.id,
          caption: field.name,
          coordinates: field.map,
        }
      },
      toHome() {
        this.$router.push({ name: 'Home' });
      },
    },
    mixins: [displaySwitches, partnerCodeEnums],

  }
</script>
